import { resizeObservers as f } from "../utils/resizeObservers.js";
import { ResizeObserverEntry as p } from "../ResizeObserverEntry.js";
import { calculateDepthForNode as g } from "./calculateDepthForNode.js";
import { calculateBoxSize as b } from "./calculateBoxSize.js";
var T = function() {
  var t = 1 / 0, s = [];
  f.forEach(function(e) {
    if (e.activeTargets.length !== 0) {
      var i = [];
      e.activeTargets.forEach(function(r) {
        var l = new p(r.target), v = g(r.target);
        i.push(l), r.lastReportedSize = b(r.target, r.observedBox), v < t && (t = v);
      }), s.push(function() {
        e.callback.call(e.observer, i, e.observer);
      }), e.activeTargets.splice(0, e.activeTargets.length);
    }
  });
  for (var a = 0, c = s; a < c.length; a++) {
    var n = c[a];
    n();
  }
  return t;
};
export {
  T as broadcastActiveObservations
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js
// module id = 1353
// module chunks = 67